/**
 * Created by kb on 2017/11/20.
 */
import Vue from 'vue'
import Vuex from 'vuex'


import system from './modules/system' //系统模块
import serverChart from './modules/serverWebChart'  //客服聊天模块
import clientChart from './modules/clientWebChart'  //客户聊天模块


import getters from './getters'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    system,
    serverChart,
    clientChart
  },
  getters,
  strict: true,
  submitCache:true,
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js